import { useCallback, useEffect, useState } from 'react';

export function useCopyToClipboard(): [boolean, (value: string) => void] {
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const copy = useCallback<(value: string) => void>(async (value: string) => {
    try {
      if ('clipboard' in window.navigator) {
        await window.navigator.clipboard.writeText(value);
      } else {
        const textAreaElement = document.createElement('textarea');
        textAreaElement.value = value;
        document.body.appendChild(textAreaElement);
        textAreaElement.select();
        document.execCommand('copy');
        document.body.removeChild(textAreaElement);
      }

      setIsCopied(true);
    } catch (error) {
      console.error('Copy failed', error);
    }
  }, []);

  useEffect(() => {
    if (isCopied) {
      const timeoutId: NodeJS.Timeout = setTimeout(() => {
        setIsCopied(false);
      }, 2500);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [isCopied]);

  return [isCopied, copy];
}
